import React from "react";
import Tab from "./Tab";  // Import the Tab component
import { projectCategories } from '../data/data'; // Import your project data

const TabsContainer = () => {
  return (
    <div style={{ gridColumn: '1 / -1' }}> {/* Span all columns */}
      {projectCategories.map((category, index) => (
        <Tab 
          key={index} 
          code={category.code} 
          introduction={category.introduction}
          title={category.title} 
          projects={category.projects} 
        />
      ))}
    </div>
  );
};

export default TabsContainer;